import {HttpClientService} from "services/httpClient/httpClientService";
import config from "config/config";
import {ApiResponse} from "services/api/apiResponse"
import {AccountService} from "../../account/accountService";
import {ForSelectModel} from "../../../core/sharedmodels/forSelectModel";
import {ForSelectResponseModel} from "../forSelectResponseModel";
import { SpecialeModel } from "core/sharedmodels/speciale/specialeModel";

export class StamdataSpecialeApi {
    private httpClientService: HttpClientService;
    private userService: AccountService;

    private baseUrl = () => config.stamdataApiUrl + "api/speciale/";

    private specialeSelectUrl = () => this.baseUrl() + "specialerForSelect";
    private specialeByBrugerMaalbeskrivelseUrl = () => this.baseUrl() + "byBrugerMaalbeskrivelse/";
    public specialerForSelectAsyncUrl = () => this.baseUrl() + "specialerForSelectAsync/";

    constructor(httpClientService: HttpClientService, userService: AccountService) {
        this.httpClientService = httpClientService;
        this.userService = userService;
    }

    async getSpecialerSelect(): Promise<ForSelectModel[]> {
        const url = this.specialeSelectUrl();
        const result = await this.httpClientService.Get<ApiResponse<ForSelectResponseModel[]>>(url);
        return result.data.map(x => new ForSelectModel(x));
    }

    async getSpecialeByBrugerMaalbeskrivelse(brugerMaalbeskrivelseId: string): Promise<SpecialeModel> {
        const url = this.specialeByBrugerMaalbeskrivelseUrl() + brugerMaalbeskrivelseId;
        const result = await this.httpClientService.Get<ApiResponse<SpecialeModel>>(url);
        return result.data;
    }

}
